import { X, Heart, AlertTriangle } from 'lucide-react';

interface PregnancyDeletedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PregnancyDeletedModal({
  isOpen,
  onClose,
}: PregnancyDeletedModalProps) {
  if (!isOpen) return null;

  return (
    <>
      <div className="bottom-sheet-backdrop" onClick={onClose} />
      <div className="bottom-sheet-container">
        <div className="bottom-sheet-modal">
          {/* Header */}
          <div className="bottom-sheet-header">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-5 h-5 text-amber-400" />
              </div>
              <h2 className="!text-lg !font-semibold text-white">Schwangerschaft beendet</h2>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-[5px] bg-white/20 flex items-center justify-center text-white hover:bg-white/30"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="bottom-sheet-content space-y-4">
            <div className="flex justify-center py-4">
              <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center">
                <Heart className="w-10 h-10 text-white/30" />
              </div>
            </div>

            <div className="text-center">
              <p className="text-white/70">
                Die Schwangerschaft, mit der du verbunden warst, wurde von deinem Partner beendet.
              </p>
              <p className="text-white/50 text-sm mt-2">
                Deine Partner-Verbindung wurde getrennt. Du kannst eine neue Schwangerschaft starten
                oder auf eine neue Einladung warten.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="bottom-sheet-footer">
            <button
              onClick={onClose}
              className="w-full py-3 rounded-xl bg-pp-orange text-white font-medium hover:bg-pp-orange/90"
            >
              Verstanden
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
